import { queryClient, useMutation, useQuery } from '../../../hooks';

import * as customersService from '../service';

export const useCustomer = (id?: string) => {
  const {
    data: customer,
    refetch: refetchCustomer,
    isPending: isCustomerFetching,
  } = useQuery({
    queryFn: async () => customersService.getCustomer(),
    queryKey: ['currentCustomer'],
    enabled: false,
  });

  const fetchCustomerById = useQuery({
    queryFn: async () => customersService.getCustomer(id),
    queryKey: ['adminCustomer', id],
    enabled: !!id,
  });

  const getCustomerFullName = useMutation({
    mutationFn: customersService.getCustomerFullName,
  });

  const updateCustomer = useMutation({
    mutationFn: customersService.updateCustomer,
    onSuccess: data => {
      queryClient.setQueryData(['currentCustomer'], data);
    },
  });

  const getCustomerLinkedAccounts = useMutation({
    mutationFn: customersService.getCustomerLinkedAccounts,
  });

  return {
    customer,
    isCustomerFetching,
    refetchCustomer,
    fetchCustomerById,
    getCustomerFullName,
    updateCustomer,
    getCustomerLinkedAccounts,
  };
};
